import { render } from "./AlipayDMF.vue?vue&type=template&id=e9b1d5fe"
import script from "./AlipayDMF.vue?vue&type=script&lang=js"
export * from "./AlipayDMF.vue?vue&type=script&lang=js"

import "./AlipayDMF.vue?vue&type=style&index=0&id=e9b1d5fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__